import { useState } from 'react';
import styles from '../../../styles/agents.module.css';

function WizardModeSelector({ onSelect, rememberPreference = false }) {
    const [selectedMode, setSelectedMode] = useState(null);
    const [remember, setRemember] = useState(rememberPreference);

    const handleSelect = (mode) => {
        setSelectedMode(mode);
        if (remember) {
            localStorage.setItem('agentWizardMode', mode);
        }
        onSelect(mode);
    };

    return (
        <div style={{ maxWidth: '900px', margin: '0 auto', padding: '2em' }}>
            <h1 style={{ fontSize: '32px', fontWeight: 600, color: '#24292e', marginBottom: '0.5em', textAlign: 'center' }}>
                Create New Agent
            </h1>
            <p style={{ fontSize: '16px', color: '#586069', textAlign: 'center', marginBottom: '3em' }}>
                Choose how you'd like to create your agent
            </p>

            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '2em',
                marginBottom: '2em'
            }}>
                {/* Testing/Exploration Mode */}
                <div
                    onClick={() => handleSelect('testing')}
                    style={{
                        padding: '2em',
                        border: selectedMode === 'testing' ? '3px solid #1f6feb' : '2px solid #e1e4e8',
                        borderRadius: '8px',
                        background: selectedMode === 'testing' ? '#f0f7ff' : 'white',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => {
                        if (selectedMode !== 'testing') {
                            e.currentTarget.style.borderColor = '#1f6feb';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (selectedMode !== 'testing') {
                            e.currentTarget.style.borderColor = '#e1e4e8';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }
                    }}
                >
                    <div style={{
                        fontSize: '32px',
                        marginBottom: '1em',
                        textAlign: 'center'
                    }}>
                        🧪
                    </div>
                    <h2 style={{
                        fontSize: '20px',
                        fontWeight: 600,
                        color: '#24292e',
                        marginBottom: '0.75em',
                        textAlign: 'center'
                    }}>
                        Testing/Exploration Mode
                    </h2>
                    <p style={{
                        fontSize: '14px',
                        color: '#586069',
                        lineHeight: '1.6',
                        marginBottom: '1em'
                    }}>
                        Comprehensive walkthrough of all features. Perfect for learning the system and exploring capabilities.
                    </p>
                    <ul style={{
                        fontSize: '13px',
                        color: '#586069',
                        paddingLeft: '1.5em',
                        lineHeight: '1.8'
                    }}>
                        <li>Guides through all aspects</li>
                        <li>Encourages trying each tool</li>
                        <li>Includes examples and tips</li>
                        <li>Test agent before saving</li>
                    </ul>
                    <div style={{
                        marginTop: '1.5em',
                        padding: '0.75em',
                        background: '#e3f2fd',
                        borderRadius: '6px',
                        fontSize: '13px',
                        color: '#1976d2',
                        textAlign: 'center',
                        fontWeight: 500
                    }}>
                        Best for: Developers, Testers, Learning
                    </div>
                </div>

                {/* Production Use Mode */}
                <div
                    onClick={() => handleSelect('production')}
                    style={{
                        padding: '2em',
                        border: selectedMode === 'production' ? '3px solid #1f6feb' : '2px solid #e1e4e8',
                        borderRadius: '8px',
                        background: selectedMode === 'production' ? '#f0f7ff' : 'white',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => {
                        if (selectedMode !== 'production') {
                            e.currentTarget.style.borderColor = '#1f6feb';
                            e.currentTarget.style.transform = 'translateY(-2px)';
                            e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                        }
                    }}
                    onMouseLeave={(e) => {
                        if (selectedMode !== 'production') {
                            e.currentTarget.style.borderColor = '#e1e4e8';
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = 'none';
                        }
                    }}
                >
                    <div style={{
                        fontSize: '32px',
                        marginBottom: '1em',
                        textAlign: 'center'
                    }}>
                        ⚡
                    </div>
                    <h2 style={{
                        fontSize: '20px',
                        fontWeight: 600,
                        color: '#24292e',
                        marginBottom: '0.75em',
                        textAlign: 'center'
                    }}>
                        Production Use Mode
                    </h2>
                    <p style={{
                        fontSize: '14px',
                        color: '#586069',
                        lineHeight: '1.6',
                        marginBottom: '1em'
                    }}>
                        Streamlined, focused on essential configuration. Get a working agent quickly.
                    </p>
                    <ul style={{
                        fontSize: '13px',
                        color: '#586069',
                        paddingLeft: '1.5em',
                        lineHeight: '1.8'
                    }}>
                        <li>Essential steps only</li>
                        <li>No forced tool exploration</li>
                        <li>Sensible defaults</li>
                        <li>Quick path to functional agent</li>
                    </ul>
                    <div style={{
                        marginTop: '1.5em',
                        padding: '0.75em',
                        background: '#e8f5e9',
                        borderRadius: '6px',
                        fontSize: '13px',
                        color: '#2e7d32',
                        textAlign: 'center',
                        fontWeight: 500
                    }}>
                        Best for: End Users, Quick Setup
                    </div>
                </div>
            </div>

            {rememberPreference && (
                <div style={{
                    textAlign: 'center',
                    marginTop: '2em',
                    padding: '1em',
                    background: '#f6f8fa',
                    borderRadius: '6px'
                }}>
                    <label style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5em',
                        cursor: 'pointer',
                        fontSize: '14px',
                        color: '#586069'
                    }}>
                        <input
                            type="checkbox"
                            checked={remember}
                            onChange={(e) => setRemember(e.target.checked)}
                        />
                        <span>Remember my preference</span>
                    </label>
                </div>
            )}
        </div>
    );
}

export default WizardModeSelector;
